module.exports = __webpack_public_path__ + "static/assets/acdd71fb35286e35a88933609182f8de.png";